// Copyright (c) 2022 by Move Closer

import { AnyObject } from '@movecloser/front-core'

export enum LastOrderItemType {
  AbandonedCart = 'abandonedCart',
  Order = 'order'
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export enum PossibleItemAction {
  GoToCart = 'goToCart',
  RetryPayment = 'retryPayment',
  ShowDetails = 'showDetails'
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export interface LastOrderItemHeadline {
  prefix?: HeadlineItemValue
  content: HeadlineItemValue
  suffix?: HeadlineItemValue
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export interface HeadlineItemValue {
  value: string
  bold: boolean
}

/**
 * @author Filip Rurak <filip.rurak@movecloser.pl>
 */
export interface LastOrderItemProps {
  /**
   * Action that can be done within component
   */
  action: string
  /**
   * Data that is passed into the component
   */
  data: AnyObject
  /**
   * Shown headline
   */
  headline: LastOrderItemHeadline
  /**
   * Defines type of LastOrderItem
   */
  type: string
}
